import { Component } from '@angular/core';
import { PanelContainerComponent } from '../../../shared/content-panels/panel-container.component';
import { PanelHeaderComponent } from 'src/app/shared/content-panels';
import { MatIcon } from '@angular/material/icon';
import { PanelBodyComponent } from '../../../shared/content-panels/panel-body.component';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { QBuiltService } from '../services/qbuilt-service';
import { QBuiltConstants } from '../models/constants/qbuilt.constants';

import { localStorageConstants } from 'src/app/shared/services';
import { MatTooltip } from '@angular/material/tooltip';
import { SpinnerService } from 'src/app/shared/services';
import { FacilityDataModel } from '../../facility-config/models/facility-config.model';
import { FacilityConfigService } from '../../facility-config/services/facility-config.service';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'checklist-table',
  imports: [
    PanelContainerComponent,
    PanelHeaderComponent,
    PanelBodyComponent,
    MatIcon,
    MatTableModule,
    MatPaginatorModule,
    MatTooltip,
  ],
  templateUrl: './checklist-table.component.html',
  styleUrl: './checklist-table.component.scss',
})
export class ChecklistTableComponent {
  dataSource = new MatTableDataSource<any>([]);
  emptyData = new MatTableDataSource([{ empty: 'row' }]);
  materialPageIndex: number = 0;

  //table chips
  activeTrue: string = this.qbuiltConstants.activeChecklistTrue;
  activeFalse: string = this.qbuiltConstants.activeChecklistFalse;

  isEditMode: boolean = false;

  tableColumns: string[] = [
    'ChecklistName',
    'Comments',
    'CreatedOn',
    'Active',
    'Actions',
  ];

  paginatorOptions = {
    paging: true,
    show: false,
    pageSizeOptions: [50, 100, 500],
    pageSize: 50,
    pageLength: 0,
    showFirstLastButtons: true,
  };

  facilityNumber: string;
  isLoading: boolean = true;
  serialNumberList: string[] = [];
  onDestroy$: Subject<void> = new Subject<void>();

  constructor(
    private router: Router,
    private qbuiltService: QBuiltService,
    public qbuiltConstants: QBuiltConstants,
    private spinnerService: SpinnerService,
    private facilityConfigService: FacilityConfigService,
  ) {}

  ngOnInit() {
    this.spinnerService.show();
    //get facilityId
    this.qbuiltService.setFacilityNumber(
      localStorageConstants.USER_FACILITIES_KEY,
    );
    this.qbuiltService.facilityNumber$.subscribe((number) => {
      this.facilityNumber = number;
    });

    this.qbuiltService.GetAllTasksByKinds();
    this.qbuiltService.tasksByKindData$.subscribe((data) => {
      localStorage.removeItem('configuredTasks');
      this.qbuiltService.setAllTasks(data.Items);
      localStorage.setItem('configuredTasks', JSON.stringify(data.Items));
    });
    this.getChecklistData(this.facilityNumber);

    this.spinnerService.hide();
  }

  getChecklistData(plantNumber: string) {
    this.qbuiltService.getInspectionConfigurationsByFacility(plantNumber);
    this.qbuiltService.checklistTableData$.subscribe((data) => {
      this.dataSource.data = data;
      this.isLoading = false;
    });

    this.checkFacilityConfig(plantNumber);
  }

  /**
   *Determines if the facility has a configuration in place
   if true - disable deleting/creating stations when editing checklist
   * @param plantNumber
   */
  checkFacilityConfig(plantNumber: any) {
    this.facilityConfigService.getConfigurationData(plantNumber);
    this.facilityConfigService.facilityData$.subscribe(
      (data: FacilityDataModel[]) => {
        if (data && data.length > 0) {
          this.facilityConfigService.setHasConfiguration(true);
          localStorage.setItem('hasConfiguration', 'true');
        } else {
          this.facilityConfigService.setHasConfiguration(false);
          localStorage.setItem('hasConfiguration', 'false');
        }
      },
    );
  }

  //formats creation date in Facility Checklist Table (may not be needed after pulling real data)
  formatDate(date: Date) {
    let newDate = new Date(date);
    return newDate.toLocaleDateString();
  }

  openTableauLink() {}

  newChecklist() {
    this.router.navigate(['/cqms/new-checklist']);
  }

editChecklist(rowData: any) {
  sessionStorage.setItem('firstFormGroup', JSON.stringify({
    checklistName: rowData.Name,
    comments: rowData.Comment
  }));
  sessionStorage.setItem('secondFormGroup', JSON.stringify({
    stationList: rowData.Stations.map((station: { Id: any; Name: any; TaskGroups: any[]; }) => ({
      id: station.Id,
      name: station.Name,
      taskGroup: station.TaskGroups.map((group: { Id: any; Name: any; Tasks: any[]; }) => ({
        id: group.Id,
        name: group.Name,
        taskList: group.Tasks
          .sort((a: any, b: any) => (a.OrderOfPresentation ?? 0) - (b.OrderOfPresentation ?? 0))
          .map((task: { Id: any; Name: any; IsRequired: any; OrderOfPresentation: any; }) => ({
            id: uuidv4(),
            taskId: task.Id,
            taskName: task.Name,
            taskType: task.IsRequired ? 'Required' : 'AOC',
            orderOfPresentation: task.OrderOfPresentation
          }))
      }))
    }))
  }));
  this.router.navigate(['/cqms/edit-checklist', rowData.Id]);
}

//breadcrumb navigation back to dashboard
navigateToDashboard() {
  this.router.navigate(['/cqms-dashboard']);
}

  ngOnDestroy() {
    sessionStorage.removeItem('requiredTaskIds');
    sessionStorage.removeItem('optionalTaskIds');
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
